// css imports
import { useContext } from "react";
import "./App.css";
import "./assets/css/additional.styles.css";
import './assets/css/bookflow.styles.css'
import "bootstrap/dist/css/bootstrap.min.css";
import { AppProvider } from "./context/AppContext";

// libraries imports
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AppContext } from "./context/AppContext";
import "bootstrap/dist/css/bootstrap.min.css";

// component imports
import Loginpage from "./pages/loginPage";
import ForgotPassword from "./pages/forgotPassword";
import Dashboard from "./pages/dashboard/Dashboard.jsx";
import ProtectedRoute from "./ProtectedRoute";
import Header from "./components/header";
import Sidebar from "./components/sidebar";
import Footer from "./components/footer";
import Dfy from "./pages/dfy";
import Reseller from "./pages/reseller";
import WhiteLabel from "./pages/whiteLabel";
import Profile from "./pages/profile";
import ResetPassword from "./pages/resetPassword";
import TrainingVideos from "./pages/trainingVideos";
import UpGradePage from "./pages/upGrade";
import AgencyCreate from "./pages/agency/create";
import AgencyList from "./pages/agency/list";
import ForgotPassReset from "./pages/forgotPassReset";
import VerifyToken from "./VerifyToken.js";

// imports for talking book
import BookList from "./pages/bookPage/BookList.jsx";
import FlipBookPreview from "./pages/bookPreview/FlipBookPreview.jsx";
import TalkingBookPreview from "./pages/bookPreview/TalkingBookPreview.jsx";
import PhotoBookPreview from "./pages/bookPreview/PhotoBookPreview.jsx";
import BookForm from "./pages/bookPage/BookForm.jsx";
import TalkingBook from "./pages/bookPage/TalkingBook.jsx";
import CreateTemplate from "./pages/bookPage/CreateTemplate.jsx";
import ManageTemplate from "./pages/bookPage/ManageTemplate.jsx";
const AppContent = () => {
	const { base_url, isSidebarOpen } = useContext(AppContext);
	return (
		<>
			<Routes>
				<Route
					path="/login"
					element={
						<ProtectedRoute isLoginRoute={true}>
							<Loginpage base_url={base_url} />
						</ProtectedRoute>
					}
				/>
				<Route
					path="/password-reset/:varificationCode"
					element={
						<ProtectedRoute isLoginRoute={true}>
							<ForgotPassReset base_url={base_url} />
						</ProtectedRoute>
					}
				/>
				<Route
					path="/enter/login"
					element={
						<ProtectedRoute isLoginRoute={true}>
							<VerifyToken base_url={base_url} />
						</ProtectedRoute>
					}
				/>
				<Route
					path="/forgot-password-request"
					element={
						<ProtectedRoute isLoginRoute={true}>
							<ForgotPassword base_url={base_url} />
							<Footer />
						</ProtectedRoute>
					}
				/>
				<Route
					path="*"
					element={
						<ProtectedRoute isLoginRoute={true}>
							<Loginpage base_url={base_url} />
						</ProtectedRoute>
					}
				/>
				<Route
					path="/dashboard"
					element={
						<ProtectedRoute>
							<Header />
							<div className="main d-flex">
								<div className="sidebar-wrapper">
									<Sidebar />
								</div>
								<div className={`content-wrapper ${isSidebarOpen ? 'pageOpen' : 'pageClose'}`}>
									<Dashboard base_url={base_url} />
								</div>
							</div>
							<Footer />
						</ProtectedRoute>
					}
				/>
				<Route
					path="/dfy"
					element={
						<ProtectedRoute packageRequiredFeature="dfy" >
							<Header />
							<div className="main d-flex">
								<div className="sidebar-wrapper">
									<Sidebar />
								</div>
								<div className={`content-wrapper ${isSidebarOpen ? 'pageOpen' : 'pageClose'}`}>
									<Dfy base_url={base_url} />
								</div>
							</div>
							<Footer />
						</ProtectedRoute>
					}
				/>
				<Route
					path="/reseller"
					element={
						<ProtectedRoute packageRequiredFeature="reseller"  >
							<Header />
							<div className="main d-flex">
								<div className="sidebar-wrapper">
									<Sidebar />
								</div>
								<div className={`content-wrapper ${isSidebarOpen ? 'pageOpen' : 'pageClose'}`}>
									<Reseller base_url={base_url} />
								</div>
							</div>
							<Footer />
						</ProtectedRoute>
					}
				/>
				<Route
					path="/profile"
					element={
						<ProtectedRoute>
							<Header />
							<div className="main d-flex">
								<div className="sidebar-wrapper">
									<Sidebar />
								</div>
								<div className={`content-wrapper ${isSidebarOpen ? 'pageOpen' : 'pageClose'}`}>
									<Profile base_url={base_url} />
								</div>
							</div>
							<Footer />
						</ProtectedRoute>
					}
				/>
				<Route
					path="/pass-reset"
					element={
						<ProtectedRoute>
							<Header />
							<div className="main d-flex">
								<div className="sidebar-wrapper">
									<Sidebar />
								</div>
								<div className={`content-wrapper ${isSidebarOpen ? 'pageOpen' : 'pageClose'}`}>
									<ResetPassword base_url={base_url} />
								</div>
							</div>
							<Footer />
						</ProtectedRoute>
					}
				/>
				<Route
					path="/whitelabel"
					element={
						<ProtectedRoute packageRequiredFeature="whitelabel" >
							<Header />
							<div className="main d-flex">
								<div className="sidebar-wrapper">
									<Sidebar />
								</div>
								<div className={`content-wrapper ${isSidebarOpen ? 'pageOpen' : 'pageClose'}`}>
									<WhiteLabel base_url={base_url} />
								</div>
							</div>
							<Footer />
						</ProtectedRoute>
					}
				/>

				<Route
					path="/training-videos"
					element={
						<ProtectedRoute  >
							<Header />
							<div className="main d-flex">
								<div className="sidebar-wrapper">
									<Sidebar />
								</div>
								<div className={`content-wrapper ${isSidebarOpen ? 'pageOpen' : 'pageClose'}`}>
									<TrainingVideos base_url={base_url} />
								</div>
							</div>
						</ProtectedRoute>
					}
				/>
				<Route
					path="/upgrade"
					element={
						<ProtectedRoute >
							<Header />
							<div className="main d-flex">
								<div className="sidebar-wrapper">
									<Sidebar />
								</div>
								<div className={`content-wrapper ${isSidebarOpen ? 'pageOpen' : 'pageClose'}`}>
									<UpGradePage base_url={base_url} />
								</div>
							</div>
						</ProtectedRoute>
					}
				/>


				<Route
					path="/create-agency"
					element={
						<ProtectedRoute packageRequiredFeature="agency"  >
							<Header />
							<div className="main d-flex">
								<div className="sidebar-wrapper">
									<Sidebar />
								</div>
								<div className={`content-wrapper transition ${isSidebarOpen ? 'pageOpen' : 'pageClose'}`}>
									<AgencyCreate base_url={base_url} />
									<Footer />
								</div>
							</div>
						</ProtectedRoute>
					}
				/>
				<Route
					path="/manage-agency"
					element={
						<ProtectedRoute packageRequiredFeature="agency"   >
							<Header />
							<div className="main d-flex">
								<div className="sidebar-wrapper">
									<Sidebar />
								</div>
								<div className={`content-wrapper ${isSidebarOpen ? 'pageOpen' : 'pageClose'}`}>
									<AgencyList base_url={base_url} />
									<Footer />
								</div>
							</div>
						</ProtectedRoute>
					}
				/>
				<Route
					path="/book/manage/:book_type"
					element={
						<ProtectedRoute>
							<Header />
							<div className="main d-flex">
								<div className="sidebar-wrapper">
									<Sidebar />
								</div>
								<div className={`content-wrapper ${isSidebarOpen ? 'pageOpen' : 'pageClose'}`}>
									<BookList base_url={base_url} />
								</div>
							</div>
							<Footer />
						</ProtectedRoute>
					}
				/>
				{<Route
					path="/book/create/:type"
					element={
						<ProtectedRoute>
							<Header />
							<div className="main d-flex">
								<div className="sidebar-wrapper">
									<Sidebar />
								</div>
								<div className={`content-wrapper ${isSidebarOpen ? 'pageOpen' : 'pageClose'}`}>
									<BookForm base_url={base_url} />
								</div>
							</div>
							<Footer />
						</ProtectedRoute>
					}
				/>}

				<Route
					path="/book/edit/:slug"
					element={
						<ProtectedRoute>
							<Header />
							<div className="main d-flex">
								<div className={`sidebar-wrapper ${isSidebarOpen ? '' : "sidebar-close"}`}>
									<Sidebar />
								</div>
								<div className={`content-wrapper ${isSidebarOpen ? 'pageOpen' : 'pageClose'}`}>
									<TalkingBook base_url={base_url} />
								</div>
							</div>
							<Footer />
						</ProtectedRoute>
					}
				/>
				<Route
					path="/book/template"
					element={
						<ProtectedRoute>
							<Header />
							<div className="main d-flex">
								<div className={`sidebar-wrapper ${isSidebarOpen ? '' : "sidebar-close"}`}>
									<Sidebar />
								</div>
								<div className={`content-wrapper ${isSidebarOpen ? 'pageOpen' : 'pageClose'}`}>
									<CreateTemplate base_url={base_url} />
								</div>
							</div>
							<Footer />
						</ProtectedRoute>
					}
				/>
				<Route
					path="/manage/book/templates"
					element={
						<ProtectedRoute>
							<Header />
							<div className="main d-flex">
								<div className={`sidebar-wrapper ${isSidebarOpen ? '' : "sidebar-close"}`}>
									<Sidebar />
								</div>
								<div className={`content-wrapper ${isSidebarOpen ? 'pageOpen' : 'pageClose'}`}>
									<ManageTemplate base_url={base_url} />
								</div>
							</div>
							<Footer />
						</ProtectedRoute>
					}
				/>

				<Route
					path="/flipbook/:slug"
					element={

						<FlipBookPreview base_url={base_url} />

					}
				/>
				<Route
					path="/talking-book/:slug"
					element={

						<TalkingBookPreview base_url={base_url} />

					}
				/>
				<Route
					path="/photobook/:slug"
					element={

						<PhotoBookPreview base_url={base_url} />

					}
				/>
			</Routes>

		</>
	);
};

function App() {
	return (
		<BrowserRouter>
			<AppProvider>
				<AppContent />
			</AppProvider>
		</BrowserRouter>
	);
}

export default App;
